<td class="text-center padding-left-0" [hidden]="!hasReceipt" style="width:20%"><i class="fas fa-paperclip"></i></td>